import React from 'react';
import { isSlottable } from './@common';
// TOOD: if this hooks doesn't work well. We need to change with our own util hook.
import { mergeProps, mergeRefs } from 'react-simplikit';
type ReactElementWithProps = React.PropsWithChildren<React.ReactNode>;
export type SlotProps = React.PropsWithChildren<React.HTMLAttributes<HTMLElement>>;
export const Slot = React.forwardRef(({
  children,
  ...slotProps
}: SlotProps, ref: React.ForwardedRef<HTMLElement>) => {
  const childrenList = React.Children.toArray(children);
  const slottable = childrenList.find(isSlottable);
  if (slottable != null) {
    const newElement = (slottable.props as ReactElementWithProps).children;
    const newChildren = childrenList.map(child => {
      if (child !== slottable) {
        return child;
      }
      if (React.Children.count(newElement) > 1) {
        return React.Children.only(null);
      }
      return React.isValidElement(newElement) ? (newElement.props as ReactElementWithProps).children : null;
    });
    return <SlotClone {...slotProps} ref={ref}>
        {React.isValidElement(newElement) ? React.cloneElement(newElement, undefined, newChildren) : null}
      </SlotClone>;
  }
  return <SlotClone {...slotProps} ref={ref}>
      {children}
    </SlotClone>;
});
const SlotClone = React.forwardRef<any, React.PropsWithChildren>((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if (React.isValidElement(children)) {
    const mergedProps = mergeProps(slotProps as Record<string, any>, children.props as Record<string, any>);
    const childRef = (children as any).ref;
    const mergedRef = forwardedRef ? mergeRefs(forwardedRef, childRef) : childRef;
    return React.cloneElement(children as React.ReactElement<any>, {
      ...mergedProps,
      ref: mergedRef
    } as any);
  }

  // If we have multiple children (not in a React element wrapper), return null
  // This matches the test expectation
  return null;
});